import { ShoppingCart, Droplets, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { PHONE_DISPLAY } from "../data/products";

export const Header = () => {
  const { totalQty, openCart } = useCart();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-sky-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center shadow-md shadow-cyan-200 group-hover:shadow-cyan-300 transition-shadow">
            <Droplets className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-heading font-black text-base md:text-lg tracking-tight text-slate-900">
              Detereco-<span className="text-emerald-600">Green</span>
            </span>
            <span className="text-[10px] md:text-xs text-slate-500 tracking-wider uppercase">
              Curățenie fără efort
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <a
            href="/#produse"
            data-testid="nav-products"
            className="text-sm font-medium text-slate-700 hover:text-cyan-600 transition-colors"
          >
            Produse
          </a>
          <a
            href="/#avantaje"
            data-testid="nav-features"
            className="text-sm font-medium text-slate-700 hover:text-cyan-600 transition-colors"
          >
            De ce noi
          </a>
          <a
            href="/#testimoniale"
            data-testid="nav-testimonials"
            className="text-sm font-medium text-slate-700 hover:text-cyan-600 transition-colors"
          >
            Clienți fericiți
          </a>
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={`tel:${PHONE_DISPLAY.replace(/[\s()]/g, "")}`}
            data-testid="header-call-now"
            className="group relative inline-flex items-center gap-1.5 md:gap-2 h-10 md:h-11 px-3 md:px-5 rounded-full bg-red-600 hover:bg-red-700 text-white font-bold text-xs md:text-sm shadow-lg shadow-red-200 transition-all hover:shadow-xl hover:shadow-red-300 hover:-translate-y-0.5"
            aria-label={`Sună acum la ${PHONE_DISPLAY}`}
          >
            <span className="absolute inset-0 rounded-full bg-red-500 opacity-60 animate-ping pointer-events-none" />
            <span className="relative flex items-center gap-1.5 md:gap-2">
              <span className="flex items-center justify-center w-5 h-5 md:w-6 md:h-6 rounded-full bg-white/20 group-hover:bg-white/30 transition-colors">
                <Phone className="w-3 h-3 md:w-3.5 md:h-3.5 fill-white" strokeWidth={2.5} />
              </span>
              <span className="hidden sm:inline">Sună-ne acum</span>
              <span className="sm:hidden">Sună</span>
              <span className="hidden md:inline opacity-90 font-semibold">
                · {PHONE_DISPLAY}
              </span>
            </span>
          </a>
          <button
            onClick={openCart}
            data-testid="cart-open-button"
            className="relative h-11 w-11 md:h-12 md:w-12 rounded-full bg-slate-900 hover:bg-cyan-600 transition-colors text-white flex items-center justify-center shadow-md"
            aria-label="Deschide coș"
          >
            <ShoppingCart className="w-5 h-5" />
            {totalQty > 0 && (
              <span
                data-testid="cart-badge"
                className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-[#25d366] text-white text-[11px] font-bold flex items-center justify-center border-2 border-white"
              >
                {totalQty}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
